import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Checkbox, FlexRow } from "@similarweb/ui-components";

export const ItemText = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[400])}
    line-height: 24px;
    padding-left: 8px;
`;

export const HighlightItemText = styled.span`
    padding-left: 8px;

    span {
        font-family: Roboto, sans-serif;
        font-size: 14px;
        line-height: 24px;
    }
`;

export const CheckboxValueWrapper = styled(FlexRow)`
    position: relative;
    padding-left: 30px;
`;

export const IconWrapper = styled.span`
    position: relative;
    z-index: 100;
    display: none;
    cursor: pointer;
`;

export const StyledCheckbox = styled(Checkbox)<{ selected: boolean }>`
    display: ${({ selected }) => (selected ? "block" : "none")};
    position: absolute;
    left: 1px;
`;

export const ListItem = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;

    padding: 0 16px;
    box-sizing: border-box;

    &:hover {
        background: ${colorsPalettes.blue[50]};
        ${IconWrapper}, ${StyledCheckbox} {
            display: block;
        }
    }
`;
